import React, { useContext, useEffect, useState } from "react";
import { defaultColorTheme } from "../../Constants/defaults";
import MachineDataContext from "../../themeContext/MachineDataContext";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import DonutChart from "./DonutChart";

interface Props {
  isShowAllMachines?: boolean;
  diameter: number;
  color?: string;
  selectedMachine?: MachinesByGroup;
  className?: string;
}

const CustomDonutChart: React.FC<Props> = (props) => {
  const { isShowAllMachines, diameter, color, selectedMachine, className = "donutchart" } = props;
  const currentMachineData = useContext(MachineDataContext);
  const [oeePercent, setOeePercent] = useState(0);
  const emptyValuePercent = oeePercent > 100 ? 0 : 100 - oeePercent;

  useEffect(() => {
    // re-org data for ease of use, based on serial number of selected machine
    if (selectedMachine != undefined && currentMachineData[selectedMachine.machineSerial] != undefined) {
      const oeeValue = currentMachineData[selectedMachine.machineSerial].oee;
      const oeePercent = oeeValue ? oeeValue * 100 : 0;
      setOeePercent(oeePercent);
    } else {
      setOeePercent(0);
    }
  }, [currentMachineData, selectedMachine]);
  const outerRadius = 0.9;
  const innerRadius = 0.6;

  return (
    <div>
      <DonutChart
        data={[
          {
            label: "",
            value: oeePercent,
          },
          {
            label: "",
            value: emptyValuePercent,
            isEmpty: true,
          },
        ]}
        isShowAllMachines={isShowAllMachines}
        legend={false}
        height={diameter}
        width={diameter}
        strokeColor={color ? color : defaultColorTheme[0]}
        colors={color ? [color] : [defaultColorTheme[0]]}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        formatValues={() => `${oeePercent.toFixed(0)}%`}
        className={className}
      />
    </div>
  );
};
export default CustomDonutChart;
